import React from "react";
import Title from "./components/Title";

function App() {
  return (
    <>
      <Title />
    </>
  );
}

export default App;
